export const SITE = {
  name: 'PageN',
  nameKo: '페이지엔',
  tagline: '웹 제작 스튜디오',
  email: 'chosw0410@naver.com',
  kakao: 'https://open.kakao.com/o/sGxPYZli',
  business: {
    company: '페이지엔',
    ceo: '조상원',
    registration: '621-49-01090'
  }
};

export const CTA_LABEL = '프로젝트 문의하기';

export const NAV_ITEMS = [
  { label: '홈', to: '/' },
  { label: '소개', to: '/about' },
  { label: '서비스', to: '/services' },
  { label: '프로젝트', to: '/projects' },
  { label: '문의', to: '/contact' }
];

export const MARQUEE_ITEMS = [
  '기업 홈페이지',
  '관리 시스템',
  '포트폴리오',
  '반응형 디자인',
  '문의 폼 연결',
  '도메인 연결',
  '검색 노출 설정',
  '배포와 운영'
];

export const PROJECTS = [
  {
    slug: 'acamanager',
    name: '아카매니저',
    nameEn: 'AcaManager',
    type: '학원 관리 시스템',
    url: 'https://www.acamanager.site/',
    domain: 'acamanager.site',
    summary: '출결부터 리포트까지, 학원 운영을 한 화면에서 처리하는 관리자 중심 웹 서비스입니다.',
    scope: ['기획', '디자인', '개발', '배포'],
    highlights: ['관리자 대시보드', '출결 관리', '리포트', '공지사항'],
    image: '/image/acamanager.webp',
    thumb: '/image/acamanager-sm.webp',
    alt: '아카매니저 학원 관리 시스템 메인 화면'
  },
  {
    slug: 'ssacc',
    name: '삼성회계법인',
    nameEn: 'SSACC',
    type: '회계법인 홈페이지',
    url: 'https://ssacc.kr/',
    domain: 'ssacc.kr',
    summary: '사회적경제 전문 회계법인의 신뢰를 전달하고 상담 신청으로 이어지는 기업 홈페이지입니다.',
    scope: ['기획', '디자인', '개발', '배포'],
    highlights: ['회사 소개', '업무 분야', '성공 사례', '상담 신청'],
    image: '/image/ssacc.webp',
    thumb: '/image/ssacc-sm.webp',
    alt: '삼성회계법인 홈페이지 메인 화면'
  }
];

export const SERVICES = [
  {
    id: 'website',
    label: '기업 홈페이지',
    title: '기업 홈페이지 제작',
    short: '회사와 서비스를 소개하고 문의로 이어지는 반응형 홈페이지. 기획부터 배포, 도메인 연결까지 한 번에 진행합니다.',
    description:
      '회사와 서비스를 소개하고 문의로 이어지는 홈페이지를 만듭니다. 전하고 싶은 메시지의 순서를 먼저 잡고, 모바일과 데스크톱 어디서 열어도 깨지지 않게 설계합니다.',
    audience: [
      '회사 소개 페이지가 필요한 소규모 사업자',
      '오래된 홈페이지를 새로 만들고 싶은 분',
      '상담 문의를 온라인으로 받고 싶은 분'
    ],
    includes: ['페이지 구성 기획', '반응형 디자인', '문의 폼 연결', '검색 노출 기본 설정', '도메인 연결과 배포'],
    chips: ['반응형 화면', '검색 노출 설정', '문의 폼 연결', '도메인 연결'],
    project: 'ssacc'
  },
  {
    id: 'system',
    label: '관리 시스템',
    title: '관리 시스템 구축',
    short: '출결, 회원, 일정처럼 매일 반복되는 업무를 관리자 화면으로 옮깁니다. 권한별 메뉴와 검색, 통계까지.',
    description:
      '엑셀과 메신저로 처리하던 업무를 관리자 화면으로 옮깁니다. 실제 운영 흐름을 먼저 듣고, 권한별 메뉴와 검색, 통계 화면을 그 흐름에 맞춰 설계합니다.',
    audience: [
      '학원, 매장처럼 회원과 일정을 관리하는 곳',
      '반복 업무에 드는 시간을 줄이고 싶은 운영팀',
      '흩어진 데이터를 한 곳에서 보고 싶은 분'
    ],
    includes: ['업무 흐름 분석', '권한별 화면 설계', '조회, 검색, 필터', '통계와 리포트', '배포와 운영 지원'],
    chips: ['관리자 대시보드', '권한별 메뉴', '검색과 필터', '통계 화면'],
    project: 'acamanager'
  },
  {
    id: 'portfolio',
    label: '포트폴리오',
    title: '포트폴리오 웹사이트',
    short: '작업물과 이력이 한눈에 들어오는 개인 사이트. 모바일에서 먼저 잘 보이게 만듭니다.',
    description:
      '작업물과 이력이 한눈에 들어오는 개인 사이트를 만듭니다. 보여주고 싶은 순서대로 구성하고, 모바일 화면에서 먼저 잘 보이도록 레이아웃을 잡습니다.',
    audience: [
      '작업물을 정리해 보여줘야 하는 디자이너와 개발자',
      '이력과 프로젝트를 한 페이지에 담고 싶은 분',
      '취업, 이직, 외주 수주용 사이트가 필요한 분'
    ],
    includes: ['작업물 큐레이션', '톤앤매너 설계', '모바일 우선 레이아웃', '연락처와 링크 연결', '도메인 연결과 배포'],
    chips: ['작업물 큐레이션', '모바일 우선', '자기소개 구성'],
    project: null
  }
];

export const PROCESS = [
  {
    title: '상담',
    description: '필요한 기능과 일정, 예산 범위를 듣고 어디까지 만들지 함께 정합니다.'
  },
  {
    title: '기획과 디자인',
    description: '화면 구성과 흐름을 먼저 확인한 뒤 디자인 시안을 만들어 확정합니다.'
  },
  {
    title: '개발',
    description: '확정된 시안대로 개발하고, 중간 결과물을 공유하며 조정합니다.'
  },
  {
    title: '배포와 운영',
    description: '도메인을 연결해 배포하고, 운영 중 생기는 수정 요청을 이어서 받습니다.'
  }
];

export const FAQ = [
  {
    question: '제작 기간은 얼마나 걸리나요?',
    answer:
      '범위에 따라 다릅니다. 상담에서 페이지 구성과 기능을 정한 뒤 일정을 안내해 드립니다. 소개용 홈페이지보다 관리 시스템이 더 오래 걸립니다.'
  },
  {
    question: '비용은 어떻게 정해지나요?',
    answer:
      '페이지 수와 기능 범위를 기준으로 견적을 드립니다. 문의하실 때 대략적인 예산 범위를 알려주시면 그 안에서 가능한 구성을 제안합니다.'
  },
  {
    question: '디자인 시안을 먼저 볼 수 있나요?',
    answer: '네. 개발을 시작하기 전에 화면 구성과 디자인 시안을 먼저 확인하고 확정합니다. 시안 단계에서 수정이 가장 쉽습니다.'
  },
  {
    question: '도메인과 호스팅도 맡길 수 있나요?',
    answer: '네. 도메인 구매와 연결, 배포까지 함께 진행합니다. 이미 쓰고 있는 도메인이 있으면 그대로 연결합니다.'
  },
  {
    question: '완성 후에 수정이 필요하면 어떻게 하나요?',
    answer:
      '배포 후에도 수정 요청을 받습니다. 문구나 이미지 교체처럼 간단한 작업부터 기능 추가까지, 범위에 따라 방법과 비용을 안내해 드립니다.'
  }
];

export const PRINCIPLES = [
  {
    title: '운영자가 쓰는 화면부터 생각합니다',
    description: '관리자 페이지와 모바일 화면을 먼저 설계합니다. 보기 좋은 것보다 매일 쓰기 편한 것이 우선입니다.'
  },
  {
    title: '한 팀이 끝까지 맡습니다',
    description: '기획, 디자인, 개발을 한 팀이 진행해 전달 과정에서 생기는 누락과 번복을 줄입니다.'
  },
  {
    title: '필요한 만큼만 만듭니다',
    description: '당장 쓰지 않을 기능은 빼고, 나중에 덧붙일 수 있도록 구조를 잡아 둡니다.'
  },
  {
    title: '배포 후에도 이어집니다',
    description: '도메인 연결과 배포, 운영 중 수정까지 같은 사람이 이어서 처리합니다.'
  }
];
